// extracted by mini-css-extract-plugin
module.exports = {"link":"_93444fe79c--link--wcE0Q","title":"_93444fe79c--title--tlXoI","image":"_93444fe79c--image--PwvlP","label":"_93444fe79c--label--Abngi"};